module.exports = __webpack_public_path__ + "static/media/create_empty.408445aa.png";